import { HttpClient } from '@angular/common/http';
import { Injectable,Inject, PLATFORM_ID  } from '@angular/core';
import { catchError, Observable, } from 'rxjs';
import { UtilsService } from './utils.service';


@Injectable({
  providedIn: 'root'
})
export class InbtHomepageService {

  constructor(private http: HttpClient, public utils: UtilsService) { }

    getHomePageData(): Observable<any> {
      let url = this.utils.apiUrl + 'LandingPage/GetCustomerBrandLandingPage';
      return this.http.get(url, { headers: this.utils.skipInterceptorHeaders }).pipe(catchError(this.utils.processError.bind(this)));
    }
}
